console.log('loadInsights 1')
let promise
export default function () {
  console.log('loadInsights 2 called', promise)
  if (promise) {
    console.log('loadInsights 3 already have promise')
    return promise
  }
  console.log('loadInsights 4 creating promise')
  promise = new Promise((resolve) => {
    console.log('loadInsights 5 running promise')
    // Insights invokes this method after all the JS has loaded
    window.insightsReady = (api) => {
      resolve(api)
    }
    /*
      To test Insights locally you'll need to build it for production using `npm run build`
      and then run a web server (I use the node `serve` cli) which can serve up the /dist/ folder.

      Use the following to get Insights to load loacally instead of from CloudFront
      // localStorage.setItem('insightsDistPath', 'https://localhost:5000/projects/insights/dist/')

      It's much faster to test Insights by loading data from the production portal:
      // localStorage.setItem('analytics_config', '{"developerMode":false,"demoMode":false,"debugFilters":false,"queryEndpoint":"//analytics-service.fanplayr.com/analytics","portalHostname":"https://portal.fanplayr.com","lastColumnPickerTag":"all"}')
    */
    const el = document.createElement('script')
    if (window.localStorage.getItem('insights_v1')) {
      // v1
      el.src = 'https://s3.amazonaws.com/fanplayr/apps/insights/boot.js'
    } else if (window.location.hostname === 'stage.fanplayr.com') {
      // new: stage
      el.src = 'https://s3.amazonaws.com/fanplayr/apps/insights/env/stage/boot.js'
    } else {
      // new: production
      el.src = 'https://s3.amazonaws.com/fanplayr/apps/insights/env/prod/boot.js'
    }
    document.body.appendChild(el)
  })
  console.log('loadInsights 6 returning promise')
  return promise
}
